import { loadLanguageAsync } from '@/setup/i18n-setup'

import Vue from 'vue'

export default () => {
  const bootstrapRTL = () => import('@laylazi/bootstrap-rtl/dist/css/bootstrap-rtl.css')

  const importCustomCss = () => import('@/assets/scss/custom.scss')

  const language = Vue.$cookies.get('Language')
  if (language && language !== 'en') {
    loadLanguageAsync(language)
  }

  if (['ar', 'iw'].includes(language)) {
    bootstrapRTL().then(() => importCustomCss())
  } else {
    importCustomCss()
  }
}
